import { useEffect, useState } from 'react';
import { HeaderLogo } from './index.styled';
import { ChurchSearchLayout } from './church-search.layout';
import { ChurchWelcomeLayout } from './church-welcome.layout';
import Logo from '../../../assets/images/full-togather-logo.svg';
import { churchSearch, churchHelper } from '../../../services/church.service';
import useDebounce from '../../../utils/hooks/use-debounce';
import { ChurchHelperComponent } from '../../custom-modal/content/choose-church-helper';
import { GratitudeContainer } from '../../custom-modal/content/gratitude-for-send-help';
import CustomModal from '../../custom-modal/index';

export const ChurchSearchContainer = ({ selectChurch }) => {
  const [isSearch, setIsSearch] = useState(false);
  const [churchList, setChurchList] = useState([]);
  const [modalType, setModalType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchTerm = useDebounce(searchValue, 500);

  useEffect(() => {
    setSearchValue('');
  }, [isSearch]);

  useEffect(() => {
    if (debouncedSearchTerm)
      churchSearch(searchValue).then((response) => {
        setChurchList(response.data.data);
      });
  }, [debouncedSearchTerm]);

  const handleModalOpen = (type) => setModalType(type);

  const handleModalClose = () => setModalType('');

  const handleSearchValue = (e) => setSearchValue(e.target.value);

  const handleSearch = (value) => setIsSearch(value);

  const getChurchHelp = (data) => churchHelper(data);

  return (
    <>
      <CustomModal
        isModalOpen={modalType}
        handleModalClose={handleModalClose}
        contentPadding={'20PX'}
        withoutCloseBtn
        width={'375'}
      >
        {modalType === 'helper' && (
          <ChurchHelperComponent
            handleModalOpen={handleModalOpen}
            getChurchHelp={getChurchHelp}
            handleModalClose={handleModalClose}
          />
        )}
        {modalType === 'gratitude' && (
          <GratitudeContainer handleModalClose={handleModalClose} />
        )}
      </CustomModal>
      <HeaderLogo>
        <Logo />
      </HeaderLogo>
      {isSearch ? (
        <ChurchSearchLayout
          handleSearch={handleSearch}
          searchValue={searchValue}
          handleSearchValue={handleSearchValue}
          churchList={churchList}
          selectChurch={selectChurch}
          handleModalOpen={handleModalOpen}
        />
      ) : (
        <ChurchWelcomeLayout
          handleSearch={handleSearch}
          handleModalOpen={handleModalOpen}
        />
      )}
    </>
  );
};
